import {
    DirectoryEntityType,
    DirectoryPharmacyAddDto,
    DirectoryPharmacyModifyDto
} from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectorySearchHelper } from "@/ContactDirectory/Helpers/DirectorySearchHelper";
import { PhoneNumberHelper } from "@/ContactDirectory/Helpers/PhoneNumberHelper";
import { DirectoryPharmacy } from "@/ContactDirectory/Models/DirectoryPharmacy";
import { DirectorySelectableEntity } from "@/ContactDirectory/Models/DirectorySelectableEntity";
import { DirectoryAddressMapper } from "./DirectoryAddressMapper";
import { DirectoryFaxNumberMapper } from "./DirectoryFaxNumberMapper";
import { DirectoryPhoneNumberMapper } from "./DirectoryPhoneNumberMapper";

export class DirectoryPharmacyMapper {
    public static toModifyDto(pharmacy: DirectoryPharmacy): DirectoryPharmacyModifyDto {
        if (!pharmacy)
            throw new Error("pharmacy cannot be null.");

        return {
            ...pharmacy,
            address: DirectoryAddressMapper.toModifyDto(pharmacy.address),
            faxNumber: DirectoryFaxNumberMapper.toDto(pharmacy.faxNumbers.firstOrDefault()),
            phoneNumber: DirectoryPhoneNumberMapper.toDto(pharmacy.phoneNumbers.firstOrDefault())
        };
    }

    public static toAddDto(pharmacy: DirectoryPharmacy): DirectoryPharmacyAddDto {
        if (!pharmacy)
            throw new Error("pharmacy cannot be null.");

        return {
            ...pharmacy,
            address: DirectoryAddressMapper.toAddDto(pharmacy.address),
            faxNumber: DirectoryFaxNumberMapper.toDto(pharmacy.faxNumbers.firstOrDefault()),
            phoneNumber: DirectoryPhoneNumberMapper.toDto(pharmacy.phoneNumbers.firstOrDefault())
        };
    }

    public static toDirectorySelectableEntity(pharmacy: DirectoryPharmacy): DirectorySelectableEntity<DirectoryPharmacy> {
        if (!pharmacy)
            return;

        return new DirectorySelectableEntity({
            id: pharmacy.id,
            type: DirectoryEntityType.Pharmacy,
            name: pharmacy.getDisplayName(),
            address: DirectorySearchHelper.formatAddress(pharmacy.address),
            phoneNumbers: pharmacy.phoneNumbers,
            faxInfos: pharmacy.faxNumbers
                .filter(p => PhoneNumberHelper.validate(p?.number, p?.countryId))
                .map(faxNumber => ({ faxNumber })),
            model: pharmacy,
            isInvalid: pharmacy.isInvalid
        });
    }
}
